/* eslint-disable global-require */
module.exports = ['howto.config.m1', 'layouts.header.m52', 'landing.search.m40', 'layouts.header.m54', 'landing.estimate.m24', 'landing.estimate.m26', 'landing.estimate.m23', 'landing.estimate.m25'];
